// Textos de las reservas de grupo de Taxi / VTC: pantallas de la empresa
// (listado, detalle, asistente y justificante) y mesa de WAIIS. Se registran
// junto al resto de vocabularios en AppComponent.
export const locale = {
  lang: 'ca',
  data: {
    RIDE_BOOKINGS: {
      STATUS: {
        REQUESTING: 'Reservant',
        CANCELLING: 'Cancel·lant',
        SCHEDULED: 'Programada',
        FAILED: 'Fallida',
        REQUESTED: 'Sol·licitada',
        CONFIRMED: 'Confirmada',
        IN_PROGRESS: 'En curs',
        COMPLETED: 'Completada',
        CANCELLED: 'Cancel·lada',
      },
      VEHICLE_STATUS: {
        PENDING: 'En cua',
        REQUESTING: 'Reservant',
        BOOKED: 'Reservat',
        FAILED: 'No reservat',
        NEEDS_ATTENTION: 'Per revisar',
        CANCELLED: 'Cancel·lat',
      },
      FAILURE_REASON: {
        PRICE_ABOVE_MAX: 'El preu ha pujat per sobre del màxim',
        PRODUCT_UNAVAILABLE: 'El producte ja no està disponible',
        FARE_EXPIRED: 'La cotització ha caducat',
        SURGE: 'El proveïdor aplica tarifa dinàmica en aquell moment',
        SCHEDULED_AT_OUT_OF_RANGE: 'El proveïdor no admet reservar per a aquella hora',
        PASSENGER_PHONE_MISSING: 'Al titular li falta el telèfon',
        HOLD_FAILED: 'No s’ha pogut retenir l’import',
        PROVIDER_TRIP_FAILED: 'El proveïdor no ha confirmat el viatge',
        PROVIDER_TRIP_REJECTED: 'El proveïdor ha rebutjat el viatge',
        PASSENGER_PHONE_INVALID: 'El telèfon del titular no és vàlid',
        UNEXPECTED_ERROR: 'Error inesperat',
        ATTEMPT_INTERRUPTED: 'L’intent s’ha interromput',
      },
      HOLD: {
        PENDING: 'Retenint l’import',
        HELD: 'Import retingut',
        FAILED: 'Retenció fallida',
      },
      CATEGORY: {
        ECONOMY: 'Econòmic',
        EXECUTIVE: 'Executiu',
        VAN: 'Van',
      },
      SERVICE: {
        ANY: 'Taxi o VTC',
        TAXI: 'Només taxi',
        VTC: 'Només VTC',
      },
      CANCELLED_BY: {
        COMPANY: 'Cancel·lada per l’empresa',
        WAIIS: 'Cancel·lada per WAIIS',
        SYSTEM: 'Cancel·lada automàticament',
      },
      MONEY_REASON: {
        INSUFFICIENT_AVAILABLE_BALANCE: 'No hi ha prou saldo al wallet de l’empresa',
        TOP_UP_FAILED: 'Ha fallat la recàrrega des de la targeta de l’empresa',
        ALREADY_SETTLED: 'La reserva ja estava liquidada',
        ERROR: 'Error inesperat en moure els diners',
      },
      EVENT: {
        REQUESTED: 'Reserva sol·licitada',
        HOLD_SUCCEEDED: 'Import màxim retingut',
        HOLD_FAILED: 'No s’ha pogut retenir l’import',
        CONFIRMED: 'Confirmada per WAIIS',
        VEHICLES_ASSIGNED: 'Vehicles assignats',
        STARTED: 'En curs',
        COMPLETED: 'Completada',
        SETTLED: 'Cobrament confirmat',
        SETTLEMENT_FAILED: 'El cobrament ha fallat',
        SETTLEMENT_RETRIED: 'Cobrament reintentat',
        CANCELLED: 'Cancel·lada',
        CANCELLATION_REQUESTED: 'Cancel·lació sol·licitada',
        CANCELLATION_FAILED: 'No s’han pogut cancel·lar tots els viatges',
        RIDE_STARTED: 'Vehicle {{position}}: viatge iniciat',
        RIDE_COMPLETED: 'Vehicle {{position}}: viatge completat',
        RIDE_CANCELLED: 'Vehicle {{position}}: viatge cancel·lat',
        RIDE_FAILED: 'Vehicle {{position}}: el viatge no ha tirat endavant',
        SETTLEMENT_REQUESTED: 'Cobrament sol·licitat',
        UNKNOWN: 'Actualització de la reserva',
        VEHICLE_BOOKED: 'Vehicle {{position}} reservat',
        VEHICLE_ATTEMPT_FAILED: 'Vehicle {{position}}: intent fallit',
        VEHICLE_FAILED: 'Vehicle {{position}} no reservat',
        VEHICLE_NEEDS_ATTENTION: 'Vehicle {{position}} per revisar',
        VEHICLES_RESOLVED: 'Reserva resolta',
        VEHICLES_RESOLVED_COUNTS: '{{booked}} reservats, {{failed}} fallits, {{needsAttention}} per revisar',
        REQUESTED_AMOUNT: 'Màxim estimat {{amount}}',
        COMPLETED_AMOUNT: 'Total {{amount}}',
        SETTLED_AMOUNT: '{{amount}} cobrats',
        RETRIED_AMOUNT: 'Es tornen a cobrar {{amount}}',
        VEHICLES_COUNT: '{{count}} vehicles',
        VEHICLES_COUNT_ONE: '1 vehicle',
        NO_COST: 'Sense cost',
        FEE: 'Cost de cancel·lació {{amount}}',
        RIDE_AMOUNT: 'Import {{amount}}',
        SETTLEMENT_AMOUNT: 'Es cobren {{amount}}',
        VEHICLES_NOT_CANCELLED: 'Sense cancel·lar: vehicle {{positions}}',
      },
      FIELD: {
        PICKUP: 'Recollida',
        CONCEPT: 'Concepte',
        COST_CENTER: 'Centre de cost',
        OFFICE: 'Seu',
        ORIGIN: 'Origen',
        DESTINATION: 'Destinació',
        ROUTE: 'Trajecte',
        PASSENGERS: 'Persones',
        VEHICLES: 'Vehicles',
        CATEGORY: 'Tipus de vehicle',
        NOTES: 'Notes internes',
        AMOUNT: 'Import',
        STATUS: 'Estat',
        CORPORATION: 'Empresa',
        CREATED_BY: 'Creada per',
        DATE: 'Data',
      },
      VEHICLES_OF: '{{count}} × {{category}}',
      VEHICLES_BOOKED: '{{booked}} de {{total}} reservats',
      PEOPLE: '{{count}} persones',
      PEOPLE_ONE: '1 persona',
      ESTIMATE_RANGE: '{{min}} – {{max}}',
      RIDE_CANCELLED: 'Cancel·lat',
      ESTIMATED: 'estimat',
      HELD_MAX: 'màxim retingut',
      NO_COST: 'Sense cost',
      FEE: 'cost de cancel·lació',
      CHARGE_FAILED: 'Cobrament fallit',
      OPEN: 'Obrir',
      RETRY: 'Reintentar',
      PREVIOUS: 'Anterior',
      NEXT: 'Següent',
      ACCEPT: 'Acceptar',
      CANCEL: 'Cancel·lar',
      BACK: 'Tornar',
      ALL_STATUSES: 'Tots els estats',
      FROM: 'Des de',
      TO: 'Fins a',
      PAGINATION: 'Mostrant {{shown}} de {{total}} reserves',
      LOAD_ERROR: 'No s’han pogut carregar les reserves.',
      FORBIDDEN: 'No tens permís per veure les reserves d’aquesta empresa.',
      TODAY: 'Avui',
      TOMORROW: 'Demà',

      COST_CENTERS: {
        TITLE: 'Centres de cost',
        SUB: 'Per imputar les reserves de grup. Opcional.',
        ADD: 'Afegeix',
        NAME: 'Nom del centre de cost',
        SAVING: 'Afegint…',
        EMPTY: 'Encara no hi ha centres de cost.',
        DUPLICATE: 'Ja hi ha un centre de cost amb aquest nom.',
        SAVE_ERROR: 'No s’ha pogut afegir el centre de cost.',
        LOAD_ERROR: 'No s’han pogut carregar els centres de cost.',
        REMOVE: 'Treu',
        REMOVE_TITLE: 'Treu «{{name}}»',
        REMOVE_TEXT: 'Les reserves que ja l’utilitzen conserven la seva etiqueta.',
        REMOVING: 'Traient…',
        REMOVED: 'Tret',
        REMOVE_ERROR: 'No s’ha pogut treure el centre de cost',
      },

      QUICK: {
        FAB: 'Reserva un taxi',
        TITLE: 'Reserva per a un grup o esdeveniment',
        SUB: 'Per sortir ara, l’empleat fa servir l’app',
        ORIGIN: 'Origen · seu o adreça',
        DESTINATION: 'Destinació',
        CONTINUE: 'Continua amb la reserva',
        MAP_BOOKING: '{{concept}} · {{when}}',
      },

      KPI: {
        NEXT: 'Propera reserva',
        NO_NEXT: 'Sense reserves properes',
        VEHICLES: '{{count}} vehicles',
        VEHICLES_ONE: '1 vehicle',
        PENDING: 'Reservant-se o per revisar',
        PENDING_HINT: 'S’estan reservant o tenen algun vehicle per revisar',
        ALL_CONFIRMED: 'Tot reservat',
        SPENT: 'Reserves · últims 30 dies',
        COMMITTED: 'Compromès en les properes: {{amount}}',
      },

      LIST: {
        ALL_OFFICES: 'Totes les seus',
        TITLE: 'Reserves de grup',
        NEW: 'Nova reserva',
        EMPTY_TITLE: 'Encara no hi ha reserves',
        EMPTY_NONE: 'Crea la primera per a un esdeveniment, una visita o un grup.',
        EMPTY_FILTERED: 'Cap reserva compleix els filtres.',
        CREATED: 'Reserva creada: estem reservant els vehicles',
        ACTIONS: 'Accions',
        DETAILS: 'Detalls',
        EMPTY_FILTERED_TITLE: 'Sense resultats',
      },

      DETAIL: {
        BACK_TO_LIST: 'Tornar al llistat',
        NOT_FOUND: 'Aquesta reserva no existeix o és d’una altra empresa.',
        LOAD_ERROR: 'No s’ha pogut carregar la reserva.',
        PRICE: 'Import',
        ESTIMATE: 'Preu estimat',
        COMMISSION_INCLUDED: 'Inclou un {{pct}} % de comissió de WAIIS',
        UNKNOWN_PASSENGER: 'Persona que ja no és a la plantilla',
        NO_VEHICLES: 'WAIIS assigna el proveïdor i els vehicles en confirmar.',
        VEHICLE: 'Vehicle {{n}}',
        PROVIDER: 'Proveïdor',
        DRIVER: 'Conductor',
        PLATE: 'Matrícula',
        VEHICLE_AMOUNT: 'Import',
        HISTORY: 'Historial',
        SHOW_HISTORY: "Veure l'historial",
        HIDE_HISTORY: "Amagar l'historial",
        PICKUP_FUTURE: 'Recollida',
        RECEIPT: 'Veure justificant',
        CANCEL: 'Cancel·lar reserva',
        NOTE_HOLD_PENDING_TITLE: 'Retenint l’import màxim',
        NOTE_HOLD_PENDING: 'En uns segons es reté {{amount}} al wallet de l’empresa. Si no hi ha saldo, es recarrega des de la seva targeta.',
        NOTE_REQUESTED_TITLE: 'Pendent que WAIIS la confirmi',
        NOTE_REQUESTED: 'Rebràs un correu quan estigui confirmada.',
        NOTE_HOLD_FAILED_TITLE: 'Cancel·lada: no s’ha pogut retenir l’import',
        NOTE_CANCELLED_BY_WAIIS_TITLE: 'WAIIS ha cancel·lat la reserva',
        NOTE_CHARGE_FAILED_TITLE: 'El cobrament ha fallat',
        NOTE_CHARGE_FAILED: 'WAIIS ho reintentarà. Mentrestant l’empresa no pot fer reserves noves ni pagar viatges d’empleats.',
        CLOSE: 'Tanca',
        PRICE_FINAL: 'final · estimat {{range}}',
        PRICE_HELD: 'estimat · retinguts {{amount}}',
        PRICE_TOTAL_HELD: 'total dels viatges · màxim retingut {{amount}}',
        NO_COST_LOWER: 'sense cost',
        VEHICLES_TITLE: 'Vehicles · {{count}} × {{category}} · {{service}}',
        DRIVER_PENDING: 'conductor i matrícula per assignar',
        REPEAT: 'Repeteix la reserva',
        BOOK_AGAIN: 'Torna a reservar',
        VEHICLES_TITLE_PRODUCT: 'Vehicles · {{count}} × {{product}}',
        TITULAR: 'Titular: {{name}}',
        VEHICLE_ATTEMPTS: '{{count}} intents',
        VEHICLE_ATTEMPTS_ONE: '1 intent',
        VEHICLE_NEEDS_ATTENTION: 'El proveïdor no ha pogut confirmar si el viatge s’ha creat: revisa-ho al seu panell abans de tornar a reservar',
        NOTE_REQUESTING_TITLE: 'Estem reservant els vehicles…',
        NOTE_REQUESTING: 'Mentrestant, aquesta reserva s’actualitza sola.',
        NOTE_FAILED_TITLE: 'No s’ha pogut reservar cap vehicle',
        NOTE_FAILED: 'Cada vehicle diu per què. Pots tornar a reservar.',
      },

      WIZARD: {
        TITLE: 'Nova reserva',
        SUB: 'Un viatge d’Uber, Cabify o Bolt per vehicle, amb un empleat com a titular. L’empresa paga.',
        STEPS_ARIA: 'Passos de la reserva',
        STEP_TRIP: 'Trajecte',
        STEP_PRODUCT: 'Producte',
        STEP_POINTS: 'Recollida i baixada',
        STEP_PASSENGERS: 'Passatgers',
        STEP_SUMMARY: 'Confirmar',
        CONCEPT_PLACEHOLDER: 'Sopar d’equip, visita d’un client…',
        CONCEPT_REQUIRED: 'Indica el concepte.',
        ADDRESS_REQUIRED: 'Tria una adreça de la llista.',
        PICKUP_HINT: 'Hora de Madrid.',
        PICKUP_REQUIRED: 'Indica la data i l’hora de recollida.',
        PICKUP_PAST: 'La recollida ha de ser en el futur.',
        PASSENGERS_RANGE: 'Entre 1 i 60 persones.',
        PASSENGERS_COUNT: 'Nombre de persones',
        PEOPLE_UNIT: 'persones',
        ORIGIN_PLACEHOLDER: 'Seu o adreça',
        DESTINATION_PLACEHOLDER: 'Adreça, aeroport, hotel…',
        DATE: 'Data',
        TIME: 'Hora de recollida',
        OPTIONAL_LOWER: 'opcional',
        COST_CENTERS_UNAVAILABLE: 'Els centres de cost s’afegeixen a Ajustos.',
        NO_COST_CENTER: 'Sense assignar',
        NO_OFFICE: 'Sense seu',
        QUOTE_ERROR: 'No s’ha pogut cotitzar el trajecte.',
        FARE_EXPIRED: 'La cotització ha caducat: tria de nou el producte.',
        PRODUCT_REQUIRED: 'Tria un producte.',
        PRODUCT_VEHICLES: '{{count}} vehicles de {{seats}} places',
        PRODUCT_VEHICLES_ONE: '1 vehicle de {{seats}} places',
        ETA: 'arriba en {{minutes}} min',
        PER_VEHICLE: '{{range}} per vehicle',
        TOTAL: 'Total',
        NO_SCHEDULING: 'No admet reservar amb antelació',
        TOO_MANY_VEHICLES: 'Més de {{max}} vehicles: divideix el grup en diverses reserves',
        POINTS_PICKUP: 'Recollida',
        POINTS_DROPOFF: 'Baixada',
        ADDRESS_OPTION: 'L’adreça triada',
        POINTS_NONE: 'El proveïdor no dona punts aquí: es fa servir l’adreça triada.',
        MAP_LABEL: 'Mapa del trajecte',
        TITULAR_HINT: 'El primer de cada vehicle és el titular del viatge.',
        ADD_GROUP: 'Afegeix un grup',
        ADD_PEOPLE: 'Afegeix persones',
        VEHICLE: 'Vehicle {{n}}',
        SEATS_USED: '{{count}} de {{seats}} places',
        TITULAR: 'Titular',
        MAKE_TITULAR: 'Fes-lo titular',
        TITULAR_NAME: 'Titular: {{name}}',
        IN_VEHICLE: 'Al vehicle {{n}}',
        VEHICLE_EMPTY: 'Afegeix almenys una persona: la primera és el titular.',
        GROUP_OVERFLOW: '{{count}} persones de {{group}} no hi caben als vehicles.',
        GROUP_OVERFLOW_ONE: '1 persona de {{group}} no hi cap als vehicles.',
        REMOVE: 'Treu',
        SEARCH_PEOPLE: 'Cerca per nom o departament…',
        SEARCH_GROUPS: 'Cerca un grup…',
        PEOPLE_NONE: 'No hi ha ningú amb aquest nom.',
        GROUPS_NONE: 'No hi ha cap grup amb aquest nom.',
        ESTIMATE: 'Preu estimat',
        COMMISSION: 'Inclou un {{pct}} % de comissió de WAIIS',
        HOLD_MAX: 'Es reté el màxim: {{amount}}',
        SUMMARY: 'Resum',
        WHEN: 'Quan',
        PRODUCT: 'Producte',
        NOTES_PLACEHOLDER: 'P. ex.: referència de l’esdeveniment, persona de contacte…',
        NOTES_HINT: 'Només les veu la teva empresa: no s’envien als conductors.',
        PAYMENT: 'Pagament',
        PAY_HOLD: 'Import màxim a retenir',
        PAY_WALLET: 'Wallet d’empresa · saldo disponible',
        PAY_TOP_UP: 'Falta saldo · es recarrega des de {{card}}',
        PAY_NO_CARD: 'Falta saldo i no hi ha targeta d’empresa: la reserva no es podrà retenir.',
        PAY_INSUFFICIENT: 'Falta saldo i la política no té recàrrega automàtica: la reserva no es podrà retenir.',
        NOT_ALLOWED: {
          FLAG_DISABLED: 'Les reserves de grup no estan activades per a la teva empresa.',
          PLAN_LOCKED: 'El teu pla no inclou les reserves de grup.',
          POLICY_INACTIVE: 'La política de viatges de l’empresa no està activa.',
          CORPORATE_DEBT: 'L’empresa té pagaments pendents: no es pot reservar fins que es liquidin.',
          BUDGET_EXHAUSTED: 'S’ha esgotat el pressupost de viatges de l’empresa.',
        },
        CONTINUE: 'Continua',
        SUBMIT: 'Reserva',
        SUBMITTING: 'Reservant…',
        SUBMIT_ERROR: 'No s’ha pogut fer la reserva.',
      },

      CANCEL_DIALOG: {
        TITLE: 'Cancel·lar la reserva',
        TEXT: '«{{concept}}», amb recollida el {{pickup}}.',
        FREE: 'Sense cost: s’allibera el que s’ha retingut ({{amount}}).',
        PROVIDER_POLICY: 'Cada viatge es cancel·la amb la política del seu proveïdor i pot tenir un cost.',
        LATE: 'Queden menys de {{hours}} h: costa {{amount}} ({{pct}} % del màxim estimat). S’allibera la resta.',
        CONFIRM: 'Cancel·lar reserva',
        SAVING: 'Cancel·lant…',
        DONE: 'Cancel·lada',
        ERROR: 'No s’ha pogut cancel·lar la reserva',
        NOT_CANCELLABLE_TITLE: 'Aquesta reserva ja no es pot cancel·lar',
        NOT_CANCELLABLE_TEXT: 'Ja està en curs o ha acabat.',
        RIDES_FAILED_TITLE: 'No s’han pogut cancel·lar tots els viatges',
        RIDES_FAILED_TEXT: 'El proveïdor no ha acceptat la cancel·lació del vehicle {{vehicles}}. La reserva continua activa amb la resta ja cancel·lada: torna-ho a provar.',
      },

      RECEIPT: {
        TITLE: 'Justificant de reserva',
        PRINT: 'Imprimir o desar en PDF',
        BACK: 'Tornar a la reserva',
        NOT_READY: 'El justificant està disponible quan la reserva es completa.',
        LOAD_ERROR: 'No s’ha pogut carregar el justificant.',
        ISSUER: 'WAIIS · Justificant de reserva de grup',
        REFERENCE: 'Referència',
        COMPLETED_AT: 'Completada el',
        VEHICLE: 'Vehicle',
        SUBTOTAL: 'Import dels vehicles',
        COMMISSION: 'Comissió de WAIIS ({{pct}} %)',
        TOTAL: 'Total',
        PAYMENT: 'Pagament',
        PAYMENT_PAID: 'Cobrat el {{date}}',
        PAYMENT_PENDING: 'Pendent de cobrament',
        PAYMENT_FAILED: 'El cobrament ha fallat',
        FOOTER: 'Carregat al wallet de l’empresa. WAIIS intermedia la reserva; el transport el presten operadors autoritzats.',
      },

      SETTINGS: {
        NOTE_TITLE: 'Regles de les reserves de grup',
        NOTE_TEXT: 'Valen per a totes les empreses. Les places limiten els passatgers de cada vehicle; la cancel·lació només s’aplica a les reserves anteriors, que gestionava WAIIS.',
        LOAD_ERROR: 'No s’han pogut carregar els ajustos de les reserves.',
        CANCEL_TITLE: 'Cancel·lació',
        CANCEL_SUB: 'Només per a les reserves anteriors, que gestionava WAIIS: quan deixa de ser gratuït cancel·lar-ne una de confirmada i quant costa després.',
        FREE_HOURS: 'Gratuït fins a (hores abans)',
        FREE_HOURS_HINT: 'Entre 0 i 720. Una reserva sol·licitada sempre es cancel·la gratis.',
        FEE_PERCENT: 'Cost després (% del màxim estimat)',
        FEE_PERCENT_HINT: 'Entre 0 i 100. Només a les reserves anteriors.',
        SEATS_TITLE: 'Places per vehicle',
        SEATS_SUB: 'En un vehicle no hi caben més passatgers que les places de la seva categoria.',
        RANGE: 'Fora de rang.',
        SAVE: 'Desa els canvis',
        SAVING: 'Desant…',
        SAVED: 'Ajustos de les reserves desats',
        SAVE_ERROR: 'No s’han pogut desar els ajustos',
        ACCEPT: 'D’acord',
      },

      DESK: {
        TITLE: 'Reserves de grup',
        SUB: 'Totes les reserves de les empreses, de la més pròxima a la més llunyana. Els vehicles es reserven sols; des d’aquí es veuen i es cancel·len amb motiu.',
        ALL_CORPORATIONS: 'Totes les empreses',
        CORPORATION_ARIA: 'Empresa',
        EMPTY: 'No hi ha reserves amb aquests filtres.',
        CANCEL: 'Cancel·lar',
        CANCEL_TITLE: 'Cancel·lar la reserva',
        CANCEL_TEXT: 'S’allibera el que s’ha retingut excepte el que cobrin els proveïdors per cancel·lar, i s’avisa a qui la va crear amb el motiu.',
        CANCEL_REASON: 'Motiu (el veurà l’empresa)',
        CANCEL_REASON_REQUIRED: 'Escriu el motiu.',
        CANCEL_DONE: 'Cancel·lada',
        CANCEL_SAVING: 'Cancel·lant…',
        ACTION_ERROR: 'No s’ha pogut completar l’acció',
      },
      DESK_DETAIL: {
        BOOKING_ID: 'Id de la reserva',
        COPY_ID: 'Copiar l’id',
        ID_COPIED: 'Copiat',
        PICKUP_META: 'Recollida {{date}}',
        OFFICE_META: 'Seu {{name}}',
        CREATED_BY_META: 'Creada per {{name}}',
        SECTION: {
          BOOKING: 'Reserva',
          ROUTE: 'Trajecte',
          AMOUNT: 'Import',
          VEHICLES: 'Vehicles',
          HISTORY: 'Historial',
        },
        SECTION_SUB: {
          BOOKING: 'Què s’ha reservat, per a quan i qui l’ha demanada.',
          ROUTE: 'On es recull el grup i on va.',
          AMOUNT: 'L’estimat, el que s’ha retingut al wallet de l’empresa i el que s’ha cobrat.',
          VEHICLES: '{{count}} × {{category}} · {{service}}',
          VEHICLES_PRODUCT: '{{count}} × {{product}}',
          HISTORY: 'El que ha passat amb la reserva, en ordre.',
        },
        CREATED_AT: 'Creada el',
        ESTIMATE: 'Estimat',
        HELD: 'Retingut',
        HELD_MAX: 'Màxim retingut',
        COMMISSION: 'Comissió de WAIIS',
        COMMISSION_PCT: '{{pct}} %',
        VEHICLES_AMOUNT: 'Import dels vehicles',
        TOTAL: 'Total',
        CHARGED: 'Cobrat',
        CHARGED_AT: 'el {{date}}',
        CANCEL_FEE: 'Cost de cancel·lació',
        VEHICLE_AMOUNT: 'Import {{amount}}',
      },
    },
  },
};
